/*
 *
 *  *
 *  *  Copyright (C) THL A29 Limited, a Tencent company. All rights reserved.
 *  *  SPDX-License-Identifier: Apache-2.0
 *  *
 *
 */

import React from 'react';
import style from './index.module.scss';

export default function PageBox({ children }: { title: string; children: React.ReactNode }) {

  return (
    <div className={style.box}>
      {children}
    </div>
  );
}
